export default __webpack_public_path__ + "static/backgroundContact-c703f58ccb1fabab6c94e09a3355fc95.jpg";